import { render, staticRenderFns } from "./RegionNew.vue?vue&type=template&id=3a19eaf2&scoped=true&"
import script from "./RegionNew.vue?vue&type=script&lang=js&"
export * from "./RegionNew.vue?vue&type=script&lang=js&"
import style0 from "./RegionNew.vue?vue&type=style&index=0&id=3a19eaf2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a19eaf2",
  null
  
)

export default component.exports